module.exports = __webpack_public_path__ + "img/agenttracker-agenttracker.d2ea0814.png";